@use "foundation/_responsive.scss";

.applet-card-body {
  span.with-image {
    max-height: 6.7em;
  }

  * {
    color: white;
  }
}
